var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "Innerdiv" } }, [
    _vm.hasResult
      ? _c("div", [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.ShowResult,
                  expression: "ShowResult",
                },
              ],
            },
            [
              _c(
                "div",
                { staticClass: "col-12" },
                _vm._l(_vm.ElasticData, function (item) {
                  return _c("div", [
                    _c(
                      "div",
                      [
                        _vm._l(_vm.ElasticData, function (item) {
                          return _c(
                            "div",
                            {
                              staticStyle: {
                                "border-bottom": "1px solid #eee !important",
                                "margin-bottom": "15px",
                              },
                            },
                            [
                              _c(
                                "elastic-search-item",
                                {
                                  attrs: {
                                    ElasticData: item,
                                    addedToCart: _vm.addedToCart,
                                    ShowRelated: _vm.ShowRelated,
                                    ShowJournalPrices: true,
                                    RequestSource: "details",
                                    ShowShoppingCartStatus:
                                      _vm.ShowShoppingCart,
                                  },
                                },
                                [
                                  _vm._v(
                                    '"\n                                       :value="translationKeywords.addToWishList"\n                                       @click="OpenwishList(item._source.productReference)" />\n                                '
                                  ),
                                  _c("input", {
                                    staticClass: "second-btn w-100",
                                    staticStyle: {
                                      "background-color": "#414751",
                                      color: "white",
                                    },
                                    attrs: {
                                      slot: "wishlistButton",
                                      type: "button",
                                      value:
                                        _vm.translationKeywords.addToWishList,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.OpenwishList(
                                          item._source.productReference
                                        )
                                      },
                                    },
                                    slot: "wishlistButton",
                                  }),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "b-card-text",
                          { staticClass: "card-details-table" },
                          [
                            _c("div", [
                              _vm.LibraryResult && _vm.LibraryResult.length > 0
                                ? _c(
                                    "table",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.ShowLibraryResult,
                                          expression: "ShowLibraryResult",
                                        },
                                      ],
                                      staticClass: "table table-hover",
                                    },
                                    [
                                      _c(
                                        "thead",
                                        _vm._l(
                                          _vm.colNames,
                                          function (ColumnNames) {
                                            return _c(
                                              "tr",
                                              {
                                                staticStyle: {
                                                  "background-color": "#eee",
                                                },
                                              },
                                              [
                                                _c(
                                                  "th",
                                                  { attrs: { width: "10%" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        ColumnNames.quantity
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("th", [
                                                  _vm._v(
                                                    _vm._s(ColumnNames.orderId)
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("th", [
                                                  _vm._v(
                                                    _vm._s(
                                                      ColumnNames.orderdate
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("th", [
                                                  _vm._v(
                                                    _vm._s(
                                                      ColumnNames.signature
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("th", [
                                                  _vm._v(
                                                    _vm._s(
                                                      ColumnNames.departmentName
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("th", [
                                                  _vm._v(
                                                    _vm._s(ColumnNames.location)
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("th", [
                                                  _vm._v(
                                                    _vm._s(
                                                      ColumnNames.orderStatus
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { hidden: "" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        ColumnNames.userName
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("th", [
                                                  _vm._v(
                                                    _vm._s(
                                                      ColumnNames.costCenter
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { hidden: "" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        ColumnNames.deliveryEntry
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "tbody",
                                        _vm._l(
                                          _vm.LibraryResult,
                                          function (item) {
                                            return _c("tr", [
                                              _c("td", [
                                                _vm._v(_vm._s(item.quantity)),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(_vm._s(item.orderid)),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.ConvertDate(
                                                      item.orderdate
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(_vm._s(item.SIGNATURE)),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(item.departmentname)
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(_vm._s(item.location)),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(item.orderstatus)
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { attrs: { hidden: "" } },
                                                [_vm._v(_vm._s(item.username))]
                                              ),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(item.costcentername)
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", {
                                                attrs: { hidden: "" },
                                              }),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _vm.showPagination
                              ? _c(
                                  "div",
                                  [
                                    _c("pagination", {
                                      attrs: {
                                        "total-pages": _vm.ResultCount,
                                        total: 5,
                                        "per-page": 5,
                                        "current-page": _vm.currentPage,
                                      },
                                      on: { pagechanged: _vm.onPageChange },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item._source.texts &&
                            item._source.texts.length > 0 &&
                            item._source.texts[0]
                              ? _c(
                                  "b-card",
                                  {
                                    staticClass: "d-block card-area-body",
                                    staticStyle: {
                                      "border-bottom":
                                        "1px solid #eee !important",
                                    },
                                    attrs: {
                                      "no-body": "",
                                      id: "productdescription",
                                    },
                                  },
                                  [
                                    _c(
                                      "b-card-header",
                                      {
                                        staticClass: "p-1",
                                        staticStyle: {
                                          "background-color": "#fff",
                                        },
                                        attrs: {
                                          "header-tag": "header",
                                          role: "tab",
                                        },
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "tab-header",
                                            staticStyle: {
                                              "border-radius": "0 !important",
                                            },
                                            attrs: { block: "", href: "#" },
                                            on: {
                                              click: function ($event) {
                                                _vm.isActive = !_vm.isActive
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.translationKeywords
                                                    .productdescription
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.isActive
                                      ? _c(
                                          "b-collapse",
                                          {
                                            attrs: {
                                              id: "accordion-1",
                                              visible: "",
                                              role: "tabpanel",
                                            },
                                          },
                                          [
                                            item._source.texts
                                              ? _c(
                                                  "b-card-body",
                                                  [
                                                    _c(
                                                      "b-card-text",
                                                      {
                                                        staticStyle: {
                                                          "max-width": "100%",
                                                        },
                                                      },
                                                      [
                                                        _vm._l(
                                                          item._source.texts,
                                                          function (text) {
                                                            return _c("div", [
                                                              text.textTypeCode ==
                                                                "Main Description" ||
                                                              text.textTypeCode ==
                                                                "Hauptbeschreibung"
                                                                ? _c("p", {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.formatetxt(
                                                                            text.text
                                                                          )
                                                                        ),
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                            ])
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          item._source.texts,
                                                          function (text) {
                                                            return _c("div", [
                                                              text.textTypeCode ==
                                                                "Long Description" ||
                                                              text.textTypeCode ==
                                                                "Langbeschreibung"
                                                                ? _c("p", {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.formatetxt(
                                                                            text.text
                                                                          )
                                                                        ),
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                            ])
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          item._source.texts,
                                                          function (text) {
                                                            return _c("div", [
                                                              text.textTypeCode ==
                                                                "Short description/annotation" ||
                                                              text.textTypeCode ==
                                                                "Kurzbeschreibung"
                                                                ? _c("p", {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.formatetxt(
                                                                            text.text
                                                                          )
                                                                        ),
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                            ])
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          item._source.texts,
                                                          function (text) {
                                                            return _c("div", [
                                                              text.textTypeCode ==
                                                                "DescriptionForReader" ||
                                                              text.textTypeCode ==
                                                                "Beschreibung für Leser"
                                                                ? _c("p", {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.formatetxt(
                                                                            text.text
                                                                          )
                                                                        ),
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                            ])
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          item._source.texts,
                                                          function (text) {
                                                            return _c("div", [
                                                              text.textTypeCode ==
                                                                "QuoteFromReviewOfPreviousEdition" ||
                                                              text.textTypeCode ==
                                                                "QuoteFromReviewOfPreviousEdition"
                                                                ? _c("p", {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.formatetxt(
                                                                            text.text
                                                                          )
                                                                        ),
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                            ])
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          item._source.texts,
                                                          function (text) {
                                                            return _c("div", [
                                                              text.textTypeCode ==
                                                                "Table Of Contents" ||
                                                              text.textTypeCode ==
                                                                "Inhaltsverzeichnis"
                                                                ? _c("p", {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.formatetxt(
                                                                            text.text
                                                                          )
                                                                        ),
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                            ])
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          item._source.texts,
                                                          function (text) {
                                                            return _c("div", [
                                                              text.textTypeCode ==
                                                                "PreviousReviewQuote" ||
                                                              text.textTypeCode ==
                                                                "PreviousReviewQuote"
                                                                ? _c("p", {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.formatetxt(
                                                                            text.text
                                                                          )
                                                                        ),
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                            ])
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          item._source.texts,
                                                          function (text) {
                                                            return _c("div", [
                                                              text.textTypeCode ==
                                                                "AuthorComments" ||
                                                              text.textTypeCode ==
                                                                "AuthorComments"
                                                                ? _c("p", {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.formatetxt(
                                                                            text.text
                                                                          )
                                                                        ),
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                            ])
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          item._source.texts,
                                                          function (text) {
                                                            return _c("div", [
                                                              (text.text
                                                                .length > 0 &&
                                                                text.textTypeCode ===
                                                                  "Biographical note") ||
                                                              text.textTypeCode ===
                                                                "Autorenporträt"
                                                                ? _c("p", [
                                                                    _vm._v(
                                                                      "Über die Verfasser:"
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              text.textTypeCode ==
                                                                "Biographical note" ||
                                                              text.textTypeCode ==
                                                                "Autorenporträt"
                                                                ? _c("p", {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.formatetxt(
                                                                            text.text
                                                                          )
                                                                        ),
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                            ])
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          item._source.pdFs,
                                                          function (pdf) {
                                                            return _c("div", [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "PdfLinks",
                                                                  attrs: {
                                                                    href: pdf.textLink,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                    " +
                                                                      _vm._s(
                                                                        pdf.textTypeCode
                                                                      ) +
                                                                      "\n                                                "
                                                                  ),
                                                                ]
                                                              ),
                                                            ])
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          item._source
                                                            .contributors,
                                                          function (
                                                            contributor
                                                          ) {
                                                            return _c(
                                                              "div",
                                                              _vm._l(
                                                                contributor.personNameIdentifiers,
                                                                function (
                                                                  idValue
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    [
                                                                      idValue.personNameidType ===
                                                                      "25"
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "contributor-section",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "p",
                                                                                {
                                                                                  key: _vm.index,
                                                                                  staticClass:
                                                                                    "biographicalTableLable mb-0",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      contributor.keyNames
                                                                                    ) +
                                                                                      ":"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  key: _vm.index,
                                                                                  staticClass:
                                                                                    "person-identifier-link biographicalTableValue",
                                                                                  attrs:
                                                                                    {
                                                                                      href: _vm.generateItemLink(
                                                                                        idValue.idvalue,
                                                                                        "personnameidentifiers",
                                                                                        contributor.keyNames
                                                                                      ),
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm
                                                                                        .translationKeywords
                                                                                        .personIdentifier
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            )
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "b-card",
                              {
                                staticClass: "d-block card-area-body",
                                staticStyle: {
                                  "border-bottom": "1px solid #eee !important",
                                },
                                attrs: {
                                  "no-body": "",
                                  id: "biographicalNote",
                                },
                              },
                              [
                                _c(
                                  "b-card-header",
                                  {
                                    staticClass: "p-1",
                                    staticStyle: { "background-color": "#fff" },
                                    attrs: {
                                      "header-tag": "header",
                                      role: "tab",
                                    },
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "tab-header",
                                        staticStyle: {
                                          "border-radius": "0 !important",
                                        },
                                        attrs: { block: "", href: "#" },
                                        on: {
                                          click: function ($event) {
                                            _vm.isHidden = !_vm.isHidden
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.translationKeywords
                                                .biographicalNote
                                            ) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                !_vm.isHidden
                                  ? _c(
                                      "b-collapse",
                                      {
                                        attrs: {
                                          id: "accordion-2",
                                          visible: "",
                                          role: "tabpanel",
                                        },
                                      },
                                      [
                                        _c(
                                          "b-card-body",
                                          [
                                            _c("b-card-text", [
                                              _c(
                                                "table",
                                                [
                                                  _vm.AuthorsList &&
                                                  _vm.AuthorsList.length > 0
                                                    ? _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableLable",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .author
                                                                  )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableValue",
                                                          },
                                                          [
                                                            _c("span", {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                },
                                                              ],
                                                            }),
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.AuthorsList
                                                              ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.EditorsList &&
                                                  !(
                                                    item._source.mediaType ==
                                                      14 ||
                                                    item._source.mediaType ==
                                                      "Journal"
                                                  )
                                                    ? _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableLable",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "  " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .editor
                                                                  )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableValue",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.EditorsList
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item._source.mediaType ==
                                                    14 ||
                                                  item._source.mediaType ==
                                                    "Journal"
                                                    ? _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableLable",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .editor
                                                                  )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableValue",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  item._source
                                                                    .contributorStatement
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item._source.isbN13Hyphens
                                                    ? _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableLable",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(" ISBN13"),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableValue",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  item._source
                                                                    .isbN13Hyphens
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item._source.isbN10Hyphens
                                                    ? _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableLable",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(" ISBN10"),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableValue",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  item._source
                                                                    .isbN10Hyphens
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item._source
                                                    .audienceDescription
                                                    ? _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableLable",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .furtherInfo_Audience
                                                                  )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableValue",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  item._source
                                                                    .audienceDescription
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item._source.mediaType ==
                                                    14 ||
                                                  item._source.mediaType ==
                                                    "Journal"
                                                    ? _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableLable",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(" ISSN"),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableValue",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  item._source
                                                                    .issn
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  (item._source.mediaType ==
                                                    14 ||
                                                    item._source.mediaType ==
                                                      "Journal") &&
                                                  item._source.termsOfNotice !=
                                                    _vm.nulls
                                                    ? _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableLable",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "  " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .termOfNotice
                                                                  )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableValue",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  item._source
                                                                    .termsOfNotice
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  (item._source.mediaType ==
                                                    14 ||
                                                    item._source.mediaType ==
                                                      "Journal") &&
                                                  item._source
                                                    .audienceDescription
                                                    ? _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableLable",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .audience
                                                                  )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableValue",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  item._source
                                                                    .audienceDescription
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    item._source.texts,
                                                    function (txt) {
                                                      return (item._source
                                                        .mediaType == 14 ||
                                                        item._source
                                                          .mediaType ==
                                                          "Journal") &&
                                                        txt.textTypeCode ==
                                                          "Description for press or other media"
                                                        ? _c("tr", [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "biographicalTableLable",
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .translationKeywords
                                                                          .termsAndConditions
                                                                      )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "biographicalTableValue",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    txt.text
                                                                  ) + "​​​​​"
                                                                ),
                                                              ]
                                                            ),
                                                          ])
                                                        : _vm._e()
                                                    }
                                                  ),
                                                  _vm._v(" "),
                                                  item._source
                                                    .publicationLanguages &&
                                                  item._source
                                                    .publicationLanguages
                                                    .length > 0
                                                    ? _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableLable",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .language
                                                                  )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableValue",
                                                          },
                                                          _vm._l(
                                                            item._source
                                                              .publicationLanguages,
                                                            function (lang) {
                                                              return _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "custom-split",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(lang)
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item._source.series &&
                                                  item._source.series.length > 0
                                                    ? _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableLable",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .Series
                                                                  )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableValue",
                                                          },
                                                          _vm._l(
                                                            item._source.series,
                                                            function (series) {
                                                              return _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "sparate-content",
                                                                },
                                                                [
                                                                  series.title &&
                                                                  series.title
                                                                    .length > 0
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              series
                                                                                .title[0]
                                                                            )
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  series.subtitle &&
                                                                  series
                                                                    .subtitle
                                                                    .length > 0
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              series
                                                                                .subtitle[0]
                                                                            )
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  series.numberWithinSeries
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              series.numberWithinSeries
                                                                            )
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  series.seriesIdentifier &&
                                                                  series
                                                                    .seriesIdentifier
                                                                    .length > 0
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              series
                                                                                .seriesIdentifier[0]
                                                                            )
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item._source.cityOfPublication
                                                    ? _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableLable",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .publicationCountry
                                                                  )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableValue",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  item._source
                                                                    .cityOfPublication
                                                                )
                                                            ),
                                                            item._source
                                                              .countryOfPublication
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    ", " +
                                                                      _vm._s(
                                                                        item
                                                                          ._source
                                                                          .countryOfPublication
                                                                      )
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item._source.measures &&
                                                  item._source.measures.length >
                                                    0
                                                    ? _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableLable",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "  " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .measures
                                                                  )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableValue",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.formatMeasurement(
                                                                    _vm.Displaymeasurement(
                                                                      item
                                                                        ._source
                                                                        .measures
                                                                    )
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item._source.price &&
                                                  item._source.price.bundle
                                                    ? _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableLable",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .bundle
                                                                  )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableValue",
                                                          },
                                                          _vm._l(
                                                            _vm.BundlePriceTxt,
                                                            function (
                                                              Bundleitem,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "span",
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      Bundleitem
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item._source.orderTime &&
                                                  item._source
                                                    .availability_Text ==
                                                    "Available"
                                                    ? _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableLable",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .orderTime
                                                                  )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "biographicalTableValue",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  item._source
                                                                    .orderTime
                                                                ) +
                                                                " " +
                                                                _vm._s(
                                                                  _vm
                                                                    .translationKeywords
                                                                    .orderTimeDays
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            item._source.newbooksClassification ||
                            item._source.wgs ||
                            item._source.thema ||
                            item._source.keywords
                              ? _c(
                                  "b-card",
                                  {
                                    staticClass: "d-block card-area-body",
                                    staticStyle: {
                                      "border-bottom":
                                        "1px solid #eee !important",
                                    },
                                    attrs: { "no-body": "", id: "keyWords" },
                                  },
                                  [
                                    _c(
                                      "b-card-header",
                                      {
                                        staticClass: "p-1",
                                        staticStyle: {
                                          "background-color": "#fff",
                                        },
                                        attrs: {
                                          "header-tag": "header",
                                          role: "tab",
                                        },
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "tab-header",
                                            staticStyle: {
                                              "border-radius": "0 !important",
                                            },
                                            attrs: { block: "", href: "#" },
                                            on: {
                                              click: function ($event) {
                                                _vm.isHide = !_vm.isHide
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.translationKeywords
                                                    .keyWords
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.isHide
                                      ? _c(
                                          "b-collapse",
                                          {
                                            attrs: {
                                              id: "accordion-3",
                                              visible: "",
                                              role: "tabpanel",
                                            },
                                          },
                                          [
                                            _c(
                                              "b-card-body",
                                              [
                                                _c("b-card-text", [
                                                  _c("table", [
                                                    item._source
                                                      .newbooksClassification &&
                                                    item._source
                                                      .newbooksClassification
                                                      .length > 0
                                                      ? _c("tr", [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableLable",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .keywords_NewbooksClassification
                                                                  ) +
                                                                  ":\n                                                    "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableValue",
                                                            },
                                                            _vm._l(
                                                              item._source
                                                                .newbooksClassification,
                                                              function (
                                                                nbClassification,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "span",
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href: _vm.generateItemLink(
                                                                            nbClassification.code,
                                                                            "newbooksClassification",
                                                                            nbClassification.display_Ger
                                                                          ),
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            nbClassification.display_Ger
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    index !=
                                                                    item._source
                                                                      .newbooksClassification
                                                                      .length -
                                                                      1
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "; "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item._source.wgs &&
                                                    item._source.wgs.length > 0
                                                      ? _c("tr", [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableLable",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .keywords_Warengruppe
                                                                  ) +
                                                                  ":\n                                                    "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableValue",
                                                            },
                                                            _vm._l(
                                                              item._source.wgs,
                                                              function (item) {
                                                                return _c(
                                                                  "span",
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href: _vm.generateItemLink(
                                                                            item.code,
                                                                            "wgs",
                                                                            item.display_Ger
                                                                          ),
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.display_Ger
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item._source.thema &&
                                                    item._source.thema.length >
                                                      0
                                                      ? _c("tr", [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableLable",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .keywords_Thema
                                                                  ) +
                                                                  ":\n                                                    "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableValue",
                                                            },
                                                            [
                                                              _vm._l(
                                                                item._source
                                                                  .thema,
                                                                function (
                                                                  thema,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "span",
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _c(
                                                                            "a",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  href: _vm.generateItemLink(
                                                                                    thema.code,
                                                                                    "thema",
                                                                                    thema.display_Ger
                                                                                  ),
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  thema.display_Ger
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          index !=
                                                                          item
                                                                            ._source
                                                                            .thema
                                                                            .length -
                                                                            1
                                                                            ? _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    "; "
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              (item._source
                                                                .thema &&
                                                                item._source
                                                                  .thema
                                                                  .length >
                                                                  0) ||
                                                              (item._source
                                                                .ort &&
                                                                item._source.ort
                                                                  .length >
                                                                  0) ||
                                                              (item._source
                                                                .sprache &&
                                                                item._source
                                                                  .sprache
                                                                  .length >
                                                                  0) ||
                                                              (item._source
                                                                .zeitepoche &&
                                                                item._source
                                                                  .zeitepoche
                                                                  .length >
                                                                  0) ||
                                                              (item._source
                                                                .bildung &&
                                                                item._source
                                                                  .bildung
                                                                  .length >
                                                                  0) ||
                                                              (item._source
                                                                .interessen &&
                                                                item._source
                                                                  .interessen
                                                                  .length >
                                                                  0) ||
                                                              (item._source
                                                                .stil &&
                                                                item._source
                                                                  .stil.length >
                                                                  0)
                                                                ? _c("div", [
                                                                    _c("br"),
                                                                  ])
                                                                : _vm._e(),
                                                            ],
                                                            2
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item._source.ort &&
                                                    item._source.ort.length > 0
                                                      ? _c("tr", [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableLable-tr-key",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .keywords_Ort
                                                                  ) +
                                                                  ":\n                                                    "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableLable-tr",
                                                            },
                                                            _vm._l(
                                                              item._source.ort,
                                                              function (
                                                                ort,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "span",
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          ort.display_Ger
                                                                        )
                                                                      ),
                                                                      index !=
                                                                      item
                                                                        ._source
                                                                        .ort
                                                                        .length -
                                                                        1
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                "; "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item._source.sprache &&
                                                    item._source.sprache
                                                      .length > 0
                                                      ? _c("tr", [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableLable-tr-key",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .keywords_Sprache
                                                                  ) +
                                                                  ":\n                                                    "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableLable-tr",
                                                            },
                                                            _vm._l(
                                                              item._source
                                                                .sprache,
                                                              function (
                                                                Sprache,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "span",
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          Sprache.display_Ger
                                                                        )
                                                                      ),
                                                                      index !=
                                                                      item
                                                                        ._source
                                                                        .sprache
                                                                        .length -
                                                                        1
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                "; "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item._source.zeitepoche &&
                                                    item._source.zeitepoche
                                                      .length > 0
                                                      ? _c("tr", [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableLable-tr-key",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .keywords_Zeitepoche
                                                                  ) +
                                                                  ":\n                                                    "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableLable-tr",
                                                            },
                                                            _vm._l(
                                                              item._source
                                                                .zeitepoche,
                                                              function (
                                                                zeitepoche,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "span",
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          zeitepoche.display_Ger
                                                                        ) + ":"
                                                                      ),
                                                                      index !=
                                                                      item
                                                                        ._source
                                                                        .zeitepoche
                                                                        .length -
                                                                        1
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                "; "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item._source.bildung &&
                                                    item._source.bildung
                                                      .length > 0
                                                      ? _c("tr", [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableLable-tr-key",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .keywords_Bildung
                                                                  ) +
                                                                  ":\n                                                    "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableLable-tr",
                                                            },
                                                            _vm._l(
                                                              item._source
                                                                .bildung,
                                                              function (
                                                                Bildung,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "span",
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          Bildung.display_Ger
                                                                        )
                                                                      ),
                                                                      index !=
                                                                      item
                                                                        ._source
                                                                        .bildung
                                                                        .length -
                                                                        1
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                "; "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item._source.interessen &&
                                                    item._source.interessen
                                                      .length > 0
                                                      ? _c("tr", [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableLable-tr-key",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .keywords_Interessen
                                                                  ) +
                                                                  ":\n                                                    "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableLable-tr",
                                                            },
                                                            _vm._l(
                                                              item._source
                                                                .interessen,
                                                              function (
                                                                Interessen,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "span",
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          Interessen.display_Ger
                                                                        )
                                                                      ),
                                                                      index !=
                                                                      item
                                                                        ._source
                                                                        .interessen
                                                                        .length -
                                                                        1
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                "; "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item._source.stil &&
                                                    item._source.stil.length > 0
                                                      ? _c("tr", [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableLable-tr-key",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .keywords_Stil
                                                                  ) +
                                                                  ":\n                                                    "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableLable-tr",
                                                            },
                                                            _vm._l(
                                                              item._source.stil,
                                                              function (
                                                                Stil,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "span",
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          Stil.display_Ger
                                                                        )
                                                                      ),
                                                                      index !=
                                                                      item
                                                                        ._source
                                                                        .stil
                                                                        .length -
                                                                        1
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                "; "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item._source.keywords &&
                                                    item._source.keywords
                                                      .length > 0
                                                      ? _c("tr", [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableLable",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .keywords_Schlagworte
                                                                  ) +
                                                                  ":\n                                                    "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableValue",
                                                            },
                                                            [
                                                              _vm._l(
                                                                item._source
                                                                  .keywords,
                                                                function (
                                                                  keyword,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "span",
                                                                    [
                                                                      index < 20
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "custom-split",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      keyword
                                                                                    )
                                                                                  ),
                                                                                  index <
                                                                                  item
                                                                                    ._source
                                                                                    .keywords
                                                                                    .length -
                                                                                    1
                                                                                    ? _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "; "
                                                                                          ),
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e(),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "span",
                                                                            {
                                                                              directives:
                                                                                [
                                                                                  {
                                                                                    name: "show",
                                                                                    rawName:
                                                                                      "v-show",
                                                                                    value:
                                                                                      _vm.showMoreKeyWords,
                                                                                    expression:
                                                                                      "showMoreKeyWords",
                                                                                  },
                                                                                ],
                                                                            },
                                                                            [
                                                                              index ==
                                                                              20
                                                                                ? _c(
                                                                                    "span",
                                                                                    [
                                                                                      _vm._v(
                                                                                        ", "
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  keyword
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              item._source
                                                                .keywords
                                                                .length > 20
                                                                ? _c(
                                                                    "a",
                                                                    {
                                                                      directives:
                                                                        [
                                                                          {
                                                                            name: "show",
                                                                            rawName:
                                                                              "v-show",
                                                                            value:
                                                                              !_vm.showMoreKeyWords,
                                                                            expression:
                                                                              "!showMoreKeyWords",
                                                                          },
                                                                        ],
                                                                      staticClass:
                                                                        "expander",
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.ShowAllKeyWords()
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "...mehr anzeigen"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            2
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item._source.motifs &&
                                                    item._source.motifs.length >
                                                      0
                                                      ? _c("tr", [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableLable",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .translationKeywords
                                                                      .keywords_Lesemotive
                                                                  ) +
                                                                  ":\n                                                    "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "keywordTableValue",
                                                            },
                                                            [
                                                              _vm._l(
                                                                item._source
                                                                  .motifs,
                                                                function (
                                                                  motif,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "span",
                                                                    [
                                                                      index < 20
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "custom-split",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      motif
                                                                                    )
                                                                                  ),
                                                                                  index <
                                                                                  item
                                                                                    ._source
                                                                                    .motifs
                                                                                    .length -
                                                                                    1
                                                                                    ? _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "; "
                                                                                          ),
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e(),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "span",
                                                                            {
                                                                              directives:
                                                                                [
                                                                                  {
                                                                                    name: "show",
                                                                                    rawName:
                                                                                      "v-show",
                                                                                    value:
                                                                                      _vm.showMoreMotifs,
                                                                                    expression:
                                                                                      "showMoreMotifs",
                                                                                  },
                                                                                ],
                                                                            },
                                                                            [
                                                                              index ==
                                                                              20
                                                                                ? _c(
                                                                                    "span",
                                                                                    [
                                                                                      _vm._v(
                                                                                        ", "
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  motif
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              item._source
                                                                .motifs.length >
                                                              20
                                                                ? _c(
                                                                    "a",
                                                                    {
                                                                      directives:
                                                                        [
                                                                          {
                                                                            name: "show",
                                                                            rawName:
                                                                              "v-show",
                                                                            value:
                                                                              !_vm.showMoreMotifs,
                                                                            expression:
                                                                              "!showMoreMotifs",
                                                                          },
                                                                        ],
                                                                      staticClass:
                                                                        "expander",
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.ShowAllMotifs()
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "...mehr anzeigen"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            2
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ]),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ])
                }),
                0
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.ShowResult && !_vm.showNotAuthMessage,
                  expression: "!ShowResult && !showNotAuthMessage",
                },
              ],
              staticClass: "text-center",
            },
            [
              _c("b-spinner", {
                attrs: { variant: "", label: "Text Centered" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showNotAuthMessage,
                  expression: "showNotAuthMessage",
                },
              ],
              staticClass: "not-authorized-message",
            },
            [
              _c("h5", { staticClass: "mb-0" }, [
                _vm._v(
                  "\n                Sie haben keinen Zugriff auf dieses Modul.\n            "
                ),
              ]),
            ]
          ),
        ])
      : _c(
          "div",
          [
            _c("h2", [_vm._v(_vm._s(_vm.translationKeywords.noResult))]),
            _vm._v(" "),
            _c("search-request", {
              attrs: {
                mode: 1,
                searchKeyword: _vm.searchRequestTerm,
                advancedSearchText: _vm.getString("advancedSearch"),
                formOpenerText: _vm.getString("searchFormTitle"),
                searchText: _vm.searchFormText,
                formTitle: _vm.getString("searchFormTitle"),
                formHelp: _vm.getString("searchFormHelp"),
                okTitle: _vm.getString("send"),
                cancelTitle: _vm.getString("cancel"),
              },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }